import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ListItemIcon, Popover } from '@mui/material';
import Button from '../Button';

const ITEM_HEIGHT = 48;

export default function LongMenu({ options, menuClassName, triggerDisabled = false }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    if (triggerDisabled) return;
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  React.useEffect(() => {
    if (triggerDisabled) setAnchorEl(null);
  }, [triggerDisabled]);

  //console.log("options", options)

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
    {/* three dots icon */}
      <IconButton
        aria-label={triggerDisabled ? 'No actions available' : 'more'}
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup={triggerDisabled ? false : 'true'}
        disabled={triggerDisabled}
        onClick={handleClick}
        className={triggerDisabled ? 'opacity-40' : ''}
      >
        <MoreVertIcon />
      </IconButton>
      {/* drop down menu */}
      <Popover
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        getContentAnchorEl={null}
        style={{
            position: 'absolute',
            right: '0',
        }}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            borderRadius: '8px',
            width: '18em',
          },
        }}
      >
        {options.map((option) => (
          //console.log("option", option)
          // if a btn has isGreyed property
          option.isGreyed ? (
          <MenuItem key={option.value}>
            <Button
              variant={"text"}
              size={"extra_small"}
              className={"!text-subtitle !text-headings !rounded-full"}>
                {option.icon}
            </Button>
            <span className={'text-subtitle'}>{option.label}</span>
          </MenuItem>
          ): ( 
          <MenuItem
            key={option.value}
            onClick={(e) => {
              e.stopPropagation();
              handleClose();
              option.click?.(e);
            }}
          >
            <Button
              variant={"text"}
              size={"extra_small"}
              className={option.iconClassName}>
                {option.icon}
            </Button>
            <span className={option.labelClass || 'text-subtitle'}>{option.label}</span>
          </MenuItem>
          )
        ))}
      </Popover>
    </div>
  );
}